// extracted by mini-css-extract-plugin
export default {"loader":"loader__cIiaL","left-to-right":"left-to-right__cULvA"};